import React from "react";
import { useRenderOn } from "src/hooks";
import styled from "styled-components";

import theme, { media } from "../../../../../../../../../theme";
import { P } from "../../../../../../../../Semantic";

const Block = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  width: 50%;
  margin-bottom: ${theme.margins.marginBig};

  img {
    margin-bottom: 10px;
  }

  &:nth-last-child(2),
  &:last-child {
    margin-bottom: 0;
  }

  ${media.laptop} {
    margin-bottom: 0;
  }
`;

const Title = styled.h3`
  padding: 0 16px;
  font-family: ${theme.fonts.subtitle};
  font-size: ${theme.fontSizes.small};
  letter-spacing: 1.56pt;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
  font-weight: initial;
`;

const Subtitles = styled.div`
  margin: 5px 0;
  font-family: ${theme.fonts.regular};
  font-size: ${theme.fontSizes.small};
  color: ${theme.colors.grey};
  text-align: center;

  ${media.laptop} {
    padding: 0 10px;
  }
`;

const Text = styled(P)``;

interface IProps {
  subtitles: string[];
  title: string;
  icon?: {
    url: string;
    width?: number;
    name?: string;
  };
}

const ReinsuranceBlock = ({ subtitles, title, icon }: IProps): JSX.Element => {
  const { lgOrUp } = useRenderOn();

  return (
    <Block>
      {icon && lgOrUp && (
        <img src={icon.url} width={icon.width} alt={icon.name} />
      )}
      <Title>{title}</Title>
      <Subtitles>
        {subtitles.map((subtitle: string, index: number) => (
          <Text key={`argument-${index}`}>{subtitle}</Text>
        ))}
      </Subtitles>
    </Block>
  );
};

export default ReinsuranceBlock;
